import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { SponsoredContentComponent } from "../../../../components/shared/SponsoredContent";
import {
  secondToTime,
  returnDate,
  convertToSlug,
  redirectionWrapper,
  getAssociationUrlPrefix
} from "../../../../util/commonFunctions";
import { showLoader, hideLoader } from "../../../../actions";
import LazyLoad from 'react-lazyload';
import ForYouSkeleton from "../../../../components/skeleton/ForYouSkeleton";


const Template = props => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return Array.isArray(props.listing)
    ? props.listing.map((item, index) => {
      let redirectUrl = getAssociationUrlPrefix(item.associationType);
      let associationId = item.associationId == null ? item.topic?.id : item.associationId;
      let associationName = item.associationName == null ? item.topic?.name : item.associationName;
      
      return (
        <React.Fragment key={item.id}>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            {isLoading ?
              <ForYouSkeleton />
              :
              <figure className="figure">
                <NavLink
                  to={{
                    pathname:
                      "/media/" +
                      convertToSlug(item.title) +
                      "?videoId=" +
                      item.id
                  }}
                >
                  <LazyLoad
                    offset={50}
                    once={true}
                    key={index}
                    height={200}
                    placeholder={<img src="/assets/svg/abiz_placeholder.svg" className="img-fluid" />}
                    debounce={500}
                  >
                    <img
                      src={item.imageUrl}
                      className="figure-img img-fluid"
                      alt={item.title}
                      width="1024px"
                      height="576px"
                    />
                  </LazyLoad>
                  <div className="duration">
                    <span></span>
                    {secondToTime(item.duration)}
                  </div>
                </NavLink>
                <div className="vodInfo text-left">
                  <NavLink
                    to={{
                      pathname:
                        "/media/" +
                        convertToSlug(item.title) +
                        "?videoId=" +
                        item.id
                    }}
                    style={{ color: "#333" }}
                  >
                    <h4>{item.title}</h4>
                  </NavLink>
                  <ul className="d-flex flex-row justify-content-between vod_com_time">
                    <li className={item.following ? "video-verified" : null}>
                      <a
                        href={`/${redirectUrl}/${associationName}/${associationId}`}
                        onClick={event => {
                          redirectionWrapper(
                            redirectUrl,
                            event,
                            associationId,
                            associationName,
                            props,
                            props.showLoader,
                            props.hideLoader
                          )
                        }
                        }
                      >
                        {associationName}
                      </a>
                    </li>
                    <li>{returnDate(item.publish_date)}</li>
                  </ul>
                </div>
              </figure>
            }

          </div>
          {props.isHavingSponsored && index + 1 == props.sponsoredAfter && (
            <SponsoredContentComponent sponsoredBy={props.sponsoredBy} />
          )}
        </React.Fragment>
      );
    })
    : null;
};

const mapDispatchToProps = dispatch => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

export default connect(null, mapDispatchToProps)(withRouter(Template));
